import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useDisplayLegalNotice } from "@/store";
import { CloseIcon } from "@roman/shared/components/Icons";
import { useIsMobile } from "@roman/shared/hooks/soccer/useIsMobile";
import { useState } from "react";

export const LegalNoticeModal = () => {
  const isMobile = useIsMobile();
  const { showLegalNotice, setIsPreventedNotice, setShowLegalNotice, setLastLegalNoticeDisplayTime } =
    useDisplayLegalNotice();

  const [isPrevented, setIsPrevented] = useState(false);

  const handleClose = () => {
    setShowLegalNotice(false);
    setIsPreventedNotice(isPrevented);
    setLastLegalNoticeDisplayTime(Date.now());
  };

  const handleLearnMore = () => {
    handleClose();
    window.open("https://thumba.jp/media/216", "_blank");
  };

  if (!isMobile) return null;

  return (
    <Dialog open={showLegalNotice} onOpenChange={setShowLegalNotice}>
      <DialogContent className="[&>button]:hidden p-0 w-[340px] md:w-[450px] h-[387px] ring-0 ring-transparent">
        <div className="relative">
          <div
            className="flex md:justify-evenly justify-between pl-[16px] pr-[16.95px] items-center bg-blue h-[119.58px]"
            style={{ backgroundImage: "url(/assets/bg.svg)" }}
          >
            <img className="w-[84.339px] h-[83px]" src="/assets/safety_icon.svg" alt="safety icon" />
            <img
              className="w-[212.006px]"
              src="/assets/safety_and_security_initiatives.png"
              alt="safety and security initiatives"
            />
          </div>
          <div className="px-[17px] mt-5">
            <div className="text-justify text-[14px] font-semibold leading-[19.6px] tracking-[-0.28px] text-gray-500">
              サンバは日本の法律を遵守したポイ活サービスで、違法なオンラインカジノやスポーツベッティングとは無関係です。
            </div>

            <div className="text-[#5C5C5C] text-[12px] font-normal leading-[15.96px] tracking-[-0.24px] mt-[11px]">
              ※オンラインカジノやスポーツベッティングは明確に違法です。
            </div>

            <Button
              className="text-lg w-full py-[10px] px-5 text-white rounded-lg font-bold mt-[22px] h-[46px]"
              variant="default"
              onClick={handleLearnMore}
            >
              今すぐ詳細を見る
            </Button>

            <div className="my-4 flex justify-center mt-[33px]">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="shouldPreventNotice"
                  className="accent-primary h-6 w-6"
                  onChange={(e) => setIsPrevented(e.target.checked)}
                />
                <label
                  htmlFor="shouldPreventNotice"
                  className="text-[10px] sm:text-xs text-dark-gray leading-4 sm:leading-5 font-medium tracking-[-0.6px]"
                >
                  次回からは表示しない
                </label>
              </div>
            </div>
          </div>
          <div className="absolute top-[-6px] right-[-5px] w-6 h-6">
            <Button
              className="p-1 w-full h-full bg-primary cursor-pointer rounded-full flex items-center justify-center border-white border-[1.146px]"
              onClick={handleClose}
            >
              <CloseIcon />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
